export interface INotificationDataId {
	paymentOrderId?: number
	swiftPaymentId?: number
	param1?: string
	param2?: string
	param3?: string
}

export enum INotificationListType {
	SWIFT_STATUS = "SWIFT_STATUS",
	PAYMENT_ORDER_STATUS = "PAYMENT_ORDER_STATUS",
	PAYROLL_STATUS = "PAYROLL_STATUS",
	REMITTANCE_STATUS = "REMITTANCE_STATUS",
	MODULAR_LOAN_STATUS = "MODULAR_LOAN_STATUS",
	INCOMING_SWIFT = "INCOMING_SWIFT",
	INCOMING_PAYMENT_ORDER = "INCOMING_PAYMENT_ORDER"
}

export interface INotificationList {
	id: number
	type: INotificationListType
	topicType: INotificationTopic
	title: string
	text: string
	isRead: boolean
	createdAt: number
	data: INotificationDataId
	imageUrl: string,
	htmlText: string,
}

export interface INotificationListUpdate extends INotificationList {
	date?: number
}

export enum INotificationTopic {
	NOTIFICATIONS_TOPICS = "NOTIFICATIONS_TOPICS",
	NOTIFICATIONS_OPERATIONS = "NOTIFICATIONS_OPERATIONS",
	NOTIFICATIONS_NEWS = "NOTIFICATIONS_NEWS",
	INIT = "INIT"
}

export interface ISendNotificationData {
	is_read?: boolean
	topicType?: INotificationTopic
	unread_first?: boolean
	elementsOnPage?: number
	pageNumber?: number
}

export interface INotificationCount {
	count: number
}

export interface INotificationCountTypeParams {
	topicType: INotificationTopic
}

export interface INotificationCountTypeData {
	count: number
	topicType: INotificationTopic
}